/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mac: NonNullable<unknown> }} Relaunch_Learning_ContentInputs */



/**
* | output |
* | --- |
* | "Do you want to restart learning for head th. {mac} ? Learning will be triggered within the next 15 minutes." |
*
* @param {Relaunch_Learning_ContentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const relaunch_learning_content = /** @type {((inputs: Relaunch_Learning_ContentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relaunch_Learning_ContentInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Do you want to restart learning for head th. ${i?.mac} ?
Learning will be triggered within the next 15 minutes.`)
	return /** @type {LocalizedString} */ (`Voulez-vous relancer un apprentissage pour la tête th. ${i?.mac} ?
L'apprentissage sera déclenché dans les 15 prochaines minutes`)
});